import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Input from '../../../../../common/form/Input'
import SubmitButton from '../../../../../common/buttons/SubmitButton'

import { removeStudentFromWaitlist } from '../../../../../../actions/waitlistActions'

import classes from './RemoveStudentForm.module.scss'
import { toast } from 'react-toastify'

const RemoveStudentForm = ({ course, waitlistEntry, closeModal }) => {
  const dispatch = useDispatch()
  const isLoading = useSelector(state => state.waitlist.isLoading)
  const [coachMessage, setCoachMessage] = useState('')

  const handleRemoveStudent = () => {
    dispatch(removeStudentFromWaitlist({ course, waitlistEntry, coachMessage }))
      .unwrap()
      .catch(() => toast.error('Something went wrong.', { position: toast.POSITION.TOP_RIGHT }))
      .finally(() => closeModal())
  }

  return (
    <>
      <div className='d-flex flex-column justify-content-center align-items-center'>
        <Input
          name='description'
          type='textarea'
          onChange={(e) => setCoachMessage(e.target.value)}
          placeholder='Insert your message to golfers here (optional)'
          value={coachMessage}
          classNames={{
            inputContainer: classes.coachMessageInputContainer,
            inputContainerWrapper: 'mt-3',
          }}
        />
      </div>
      <div>
        <div className='row py-3 justify-content-center align-items-center'>
          <div className='col-12'>
            <SubmitButton
              onClick={handleRemoveStudent}
              buttonMessage='Remove from Waitlist'
              buttonColor='orange-button'
              loading={isLoading}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </>
  )
}

RemoveStudentForm.propTypes = {
  course: PropTypes.shape({
    id: PropTypes.number,
    isCompleted: PropTypes.bool,
  }),
  waitlistEntry: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  closeModal: PropTypes.func,
}

export default RemoveStudentForm
